import { albumActionTypes } from './album-action-types';
import { authorizedRequest } from '../../common/request';
import { albumItemActionTypes } from './album-item-action-types';
import {assetContainerTypes} from "../../assetContainer/actions/asset-container-action-types";
import {setCurrentUploadAlbum} from "../../uploadController/actions/uploadController-actions"
export const requestAlbumList = async (dispatch, offset = 0) => {
	return albumListRequested(dispatch, offset, true);
};

export const requestAlbumListForSelection = async (dispatch, offset, max = 10) => {
	return albumListRequested(dispatch, offset, false, max, true);
};

export const toggleAlbumSelection = (albumId, partial) => {
	return {
		type: albumActionTypes.ALBUM_TOGGLE_SELECTED,
		albumId: albumId,
		partial: partial
	}
}
export const selectAlbum = albumId => {
	return {
		type: albumActionTypes.ALBUM_SELECTED,
		albumId: albumId
	};
};

export const deselectAlbum = albumId => {
	return {
		type: albumActionTypes.ALBUM_DESELECTED,
		albumId: albumId
	};
};

export const clearSelectedAlbums = () => {
	return {
		type: albumActionTypes.CLEAR_ALBUM_SELECTION
	};
};
export const selectAllAlbums = () => {
	return {
		type: albumActionTypes.SELECT_ALL_ALBUMS
	}
}

export const clearAllAlbums = () => {
	return {
		type: albumActionTypes.ALBUM_LIST_CLEAR
	};
};
export const convertSortToParts = (orderBy) => {
    if("alpha(asc)" == orderBy) {
        return {sortCol:"title",sortDir:"asc"};
    }else if("alpha(desc)" == orderBy){
        return {sortCol:"title",sortDir:"desc"};
    }else if("date(asc)" == orderBy){
        return {sortCol:"createDate",sortDir:"asc"};
    }else if("date(desc)" == orderBy){
        return {sortCol:"createDate",sortDir:"desc"};
    }else{
        return {sortCol:"displayOrder",sortDir:"asc"};
    }

}
export const albumListRequested = (dispatch, offset, deep = false, max = 10, forSelection = false, amIfetching = false,sortCol=null,sortDir=null ) => {

	if(amIfetching){
		return {
			type: albumActionTypes.ALBUM_LIST_WAIT
		};

	}
	else{
		if(sortCol == null){
			let sortParts = localStorage.getItem("defaultSort") || "custom"
			sortCol = convertSortToParts(sortParts).sortCol;
            sortDir = convertSortToParts(sortParts).sortDir;
		}
		authorizedRequest(
			`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs?offset=${offset}&max=${max}&format=${deep ? 'deep':'fast'}&sort=${sortCol}&order=${sortDir}`
		)
			.then(
				albumList => dispatch(albumListReceived(albumList))
			)
			.catch(error => dispatch(albumListRequestFailed(error)));

		return {
			type: albumActionTypes.ALBUM_LIST_REQUEST
		};
	}
};
export const albumItemsRemoved = (ids) => {
	return{
		type: albumItemActionTypes.ALBUM_ITEM_DELETED,
		ids: ids
	}
}
export const requestAlbum = (dispatch, id) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${id}?format=deep`)
		.then(albumData => dispatch(albumUpdated(albumData,id)))
		.catch(error => dispatch(albumRequestFailed(error)));

	return {
		type: albumActionTypes.ALBUM_REQUEST
	};
};
export const addAlbumToAlbum = (dispatch, toAlbumId, fromAlbumId, deleteOriginal = false) => {
    authorizedRequest(
        `${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${toAlbumId}/add/cc/${fromAlbumId}?deleteOriginal=${deleteOriginal}`,
        null,
        'PUT'
    )
        .then(album => {
			if(deleteOriginal){
				dispatch(albumDeleted(fromAlbumId))
			}
			dispatch(albumCreated(album))
		})
        .catch(error => dispatch(albumCreationFailed(error)));

    return {
        type: albumActionTypes.ALBUM_CREATION_REQUEST
    };
}
export const requestAlbumCreation = (dispatch, title, description) => {
	authorizedRequest(
		`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs`,
		{ title: title, description: description },
		'POST'
	)
		.then(album => {
			dispatch(albumCreated(album))
			//make it the selected album for uploads
			dispatch(setCurrentUploadAlbum(album.id, album.title))
		})
		.catch(error => dispatch(albumCreationFailed(error)));

	return {
		type: albumActionTypes.ALBUM_CREATION_REQUEST
	};
};

export const requestAlbumUpdate = (dispatch, id, updateData) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${id}?format=deep`, updateData, 'PUT')
		.then((album) => {
			dispatch(albumUpdated(album, id))
		})
		.catch(error => dispatch(albumUpdateFailed(error)));

	return {
		type: albumActionTypes.ALBUM_UPDATE_REQUEST,
	};
};

export const requestAlbumDelete = (dispatch, id) => {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${id}`, null, 'DELETE')
		.then(() => dispatch(albumDeleted(id)))
		.catch(error => dispatch(albumDeleteFailed(id, error)));

	return {
		type: albumActionTypes.ALBUM_DELETE_REQUEST
	};
};

export const requestAddAlbumToAlbum = (dispatch, targetAlbumId, sourceAlbumId,deleteOriginal) => {
	const uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${targetAlbumId}/add/cc/${sourceAlbumId}?deleteOriginal=${deleteOriginal === true}&format=deep`;
	authorizedRequest(uri, null, 'PUT')
		.then(data => {
			if(deleteOriginal){
				dispatch(albumDeleted(sourceAlbumId))
			}
			dispatch(addAlbumToAlbumSuccess({targetAlbum: data, sourceAlbumId: sourceAlbumId, deleteOriginal: deleteOriginal}))
		})
		.catch(error => dispatch(addAlbumToAlbumFailure(error)));

	return {
		type: albumActionTypes.ALBUM_ADD_TO_ALBUM_REQUEST
	};
};
export const requestAddAlbumsToAlbum = (dispatch, targetAlbumId, sourceAlbumIds,deleteOriginal) => {
	const uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${targetAlbumId}/add/cc?deleteOriginal=${deleteOriginal === true}&format=deep`;
	authorizedRequest(uri, sourceAlbumIds, 'PUT')
		.then(data => {
			if(deleteOriginal){
				for(let i=0;i<sourceAlbumIds.length;i++) {
					dispatch(albumDeleted(sourceAlbumIds[i]))
				}
			}
			dispatch(addAlbumsToAlbumSuccess({targetAlbum: data, sourceAlbumIds: sourceAlbumIds, deleteOriginal: deleteOriginal}))
		})
		.catch(error => dispatch(addAlbumToAlbumFailure(error)));

	return {
		type: albumActionTypes.ALBUM_ADD_TO_ALBUM_REQUEST
	};
};

export const requestAddAlbumToDvd = (dispatch, targetDvdId, sourceAlbumId) => {
	const uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/dvdpkg/${targetDvdId}/add/cc/${sourceAlbumId}`;
	authorizedRequest(uri, null, 'PUT')
		.then(data => dispatch(addAlbumToDvdSuccess(data)))
		.catch(error => dispatch(addAlbumToDvdFailure(error)));

	return {
		type: albumActionTypes.ALBUM_ADD_TO_DISC_REQUEST
	};
};

export const requestAddElementsToAlbum = (dispatch, targetAlbumId, elementIdList) => {
	const uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${targetAlbumId}/add/cce`;
	authorizedRequest(uri, JSON.stringify(elementIdList), 'PUT')
		.then(data => dispatch(addElementsToAlbumSuccess(data)))
		.catch(error => dispatch(addElementsToAlbumFailure(error)));

	return {
		type: albumActionTypes.ALBUM_ADD_ELEMENT_REQUEST
	};
};

export const favoriteSelectedItems = (dispatch, ids) => {
	ids.forEach(id => {
		dispatch(requestAlbumUpdate(dispatch, id, { favoriteYn: 'Y' }));
	});

	return {
		type: albumActionTypes.ALBUM_FAVORIATE_REQUEST
	};
};

export const deleteAlbums = (dispatch, ids) => {
	ids.forEach(id => {
		dispatch(requestAlbumDelete(dispatch, id));
	});

	return {
		type: albumActionTypes.ALBUM_DELETE_REQUEST
	};
};

export const addListToAlbum = (dispatch, targetAlbumId, sourceAlbumIds, deleteOriginal = false) => {
	// sourceAlbumIds.forEach(id => {
	// 	dispatch(requestAddAlbumToAlbum(dispatch, targetAlbumId, id));
	// });
	dispatch(requestAddAlbumsToAlbum(dispatch,targetAlbumId,sourceAlbumIds, deleteOriginal));

	return {
		type: albumActionTypes.ALBUM_ADD_TO_ALBUM_REQUEST
	};
};

export const addListToDvd = (dispatch, targetDvdId, sourceAlbumIds) => {
	sourceAlbumIds.forEach(albumId => {
		dispatch(requestAddAlbumToDvd(dispatch, targetDvdId, albumId));
	});

	return {
		type: albumActionTypes.ALBUM_ADD_TO_DISC_REQUEST
	};
};



const albumRequestFailed = error => {
	return {
		type: albumActionTypes.ALBUM_REQUEST_FAILED,
		error: error
	};
};

const albumListReceived = albumList => {

	const albums = albumList.results;
	const count = albumList.count;
	const offset = albumList.offset + albums.length;
	const offsetStart = albumList.offset;
	const max = albumList.max;
	const isComplete = albumList.offset + albums.length === count;
	const ids = typeof(albumList.ids) === "undefined"?[]:albumList.ids
	return {
		type: albumActionTypes.ALBUM_LIST_RECEIVED,
		albums,
		offset,
		offsetStart,
		isComplete,
		count,
		max,
		ids
	};
};

const selectionAlbumListReceived = albumList => {
	alert("Should not be here - album-actions")
	return {
		type: albumActionTypes.ALBUM_SELECTION_LIST_RECEIVED,
		albums: albumList.results
	};
};

const albumListRequestFailed = error => {
	return {
		type: albumActionTypes.ALBUM_LIST_FAILED,
		error: error
	};
};

export const albumCreated = album => {
	return {
		type: albumActionTypes.ALBUM_CREATED,
		album: album
	};
};

export const albumCreationFailed = error => {
	return {
		type: albumActionTypes.ALBUM_CREATION_FAILED,
		error: error
	};
};

const albumUpdated = (albumItem, albumId) => {
	return {
		id: albumId,
		type: albumActionTypes.ALBUM_UPDATED,
		albumItem: albumItem
	};
};

const albumUpdateFailed = error => {
	return {
		type: albumActionTypes.ALBUM_UPDATE_FAILED,
		error: error
	};
};

const albumDeleted = id => {
	return {
		type: albumActionTypes.ALBUM_DELETED,
		albumId: parseInt(id, 10)
	};
};

const albumDeleteFailed = (id, error) => {
	return {
		type: albumActionTypes.ALBUM_DELETE_FAILED,
		id: id,
		error: error
	};
};

const addAlbumToAlbumSuccess = data => {
	return {
		type: albumActionTypes.ALBUM_ADD_TO_ALBUM_SUCCESS,
		data: data
	};
};
const addAlbumsToAlbumSuccess = data => {
	return {
		type: albumActionTypes.ALBUMS_ADD_TO_ALBUM_SUCCESS,
		data: data
	};
};
const addAlbumToAlbumFailure = error => {
	return {
		type: albumActionTypes.ALBUM_ADD_TO_ALBUM_FAILED,
		error: error
	};
};

const addElementsToAlbumSuccess = data => {
	return {
		type: albumActionTypes.ALBUM_ADD_ELEMENT_SUCCESS,
		data: data
	};
};

const addElementsToAlbumFailure = error => {
	return {
		type: albumActionTypes.ALBUM_ADD_ELEMENT_FAILURE,
		error: error
	};
};

const addAlbumToDvdSuccess = data => {
	return {
		type: albumActionTypes.ALBUM_ADD_TO_DISC_SUCCESS,
		data: data
	};
};

const addAlbumToDvdFailure = error => {
	return {
		type: albumActionTypes.ALBUM_ADD_TO_DISC_FAILED,
		error: error
	};
};

export const getAlbumInArrayById = (albumArray, id) => {
	for(let i=0;i<albumArray.length;i++){
		if(albumArray[i].id === id){
			return albumArray[i];
		}
	}
	return null;
}
export const recordScrollPosition = (scrollPosition) =>{
	return {
		type: albumActionTypes.ALBUM_SCROLL,
		scrollPosition: scrollPosition
	}
}
export const setAlbumSort = (orderBy) => {
	return {
		type: albumActionTypes.ALBUM_SORT,
        orderBy: orderBy
	}
}

export const toggleResort = () => {

    return {
        type: albumActionTypes.ALBUM_TOGGLE_RESORT,

    };
};

export const startResort = (originalValues) => {

    return {
        type: albumActionTypes.ALBUM_START_RESORT,
        originalValues

    };
};


export const cancelResort = (originalValues) => {

    return {
        type: albumActionTypes.ALBUM_CANCEL_RESORT,
        originalValues

    };
};
export const stopResort = () => {

    return {
        type: albumActionTypes.ASSET_CONTAINER_STOP_RESORT,

    };
};

export const moveAssetAfter = (itemToMove, itemToMoveAfter) => {
    return {
        type: albumActionTypes.ALBUM_MOVE_ASSET_AFTER,
        element: {assetId: itemToMove, moveAfterAssetId: itemToMoveAfter}
    };
};

export const saveArrangedAlbums = (dispatch, request) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs`;

    uri += "/displayorder";
    authorizedRequest(uri, request, "POST")
        .then((data)=>{

                dispatch({
                    type: albumActionTypes.ALBUM_SAVE_ALBUM_SORT_SUCCESS,
                    element:request
                });

            }
        )
        .catch(error => {
                alert(JSON.stringify(error));
                dispatch({
                    type: albumActionTypes.ALBUM_SAVE_ALBUM_SORT_FAILURE,
                    element: error
                });
            }
        );

    return {
        type: albumActionTypes.ALBUM_SAVE_ALBUM_SORT
    };
};

export const dragStart  = (dragDropData) => {
    return {
        type: albumActionTypes.ALBUM_DRAG_START,
        dragDropData: dragDropData
    }
}
export const setAlbumArrangeMode = (flag) => {
    return {
        type: albumActionTypes.ALBUM_TOGGLE_ARRANGE_MODE,
		flag: flag
    }
}


// WEBPACK FOOTER //
// ./src/album-view/actions/album-actions.js